import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, isRef as _isRef } from "vue"

const _hoisted_1 = { class: "content-wrapper mt-3" }
const _hoisted_2 = { class: "content-header" }
const _hoisted_3 = { class: "flex scroll-content" }
const _hoisted_4 = { class: "flex" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "on-desktop" }, "Remove Blocklists", -1)
const _hoisted_6 = { class: "blocks__format-item" }
const _hoisted_7 = { class: "table__actions" }

import { computed, onMounted, reactive, ref } from 'vue';
import { useBlockListsStore } from '@/stores/blocks';
import { useDialogStore } from '@/stores/dialogs';
import { useConfirmModal } from '@/stores/confirm-modal';
import { useTitle } from '@vueuse/core';
import { useUiStore } from '@/stores/ui';
import TheHeader from '@/components/TheHeader.vue';
import VButton from '@/components/VButton.vue';
import VAuthInput from '@/components/VAuthInput.vue';
import SearchIcon from '@/components/icons/other/SearchIcon.vue';
import VSocialSelect from '@/components/VSocialSelect.vue';
import AddIcon from '@/components/icons/other/AddIcon.vue';
import EmptyBMs from '@/components/EmptyBMs.vue';
import Table from '@/components/Table.vue';
import IconButton from '@/components/VIconButton.vue'
import CreateBlockListDialog from '@/components/dialogs/CreateBlockListDialog.vue';
import EditIcon from '@/components/icons/actions/EditIcon.vue';
import CopyIcon from '@/components/icons/actions/CopyIcon.vue';
import DeleteIcon from '@/components/icons/other/DeleteIcon.vue';
import AssetsCell from '@/components/AssetsCell.vue';



export default /*#__PURE__*/_defineComponent({
  __name: 'BlockList',
  setup(__props) {

const blockListsStore = useBlockListsStore()
onMounted(async () => {
  await blockListsStore.requestAll()
})

const columns = {
  name: { title: "Blocklist", minWidth: 120},
  assets: { title: "Involved Assets", fallback: "-", minWidth: 150 },
  block_words: { title: "Block words", sort: true },
  blockFormats: { title: "Block formats", width: 200, class: "block-formats", filters: [
    { title: "Links", filter: (item: any) => item["links"] },
    { title: "Images", filter: (item: any) => item["images"] },
    { title: "Animated Images", filter: (item: any) => item["animated_images"] },
    { title: "Stickers", filter: (item: any) => item["stickers"] },
    { title: "Phone numbers", filter: (item: any) => item["phone_numbers"] },
    { title: "Emails", filter: (item: any) => item["emails"] }
  ] },
  actions: { title: "", width: 120 }
}

const formats = [ "links", "images", "animated_images", "stickers", "phone_numbers", "emails" ]

const socialValue = ref<string | null>(null)

const getAssets = (item: any) => {
  return [ ...item.businesses, ...item.pages, ...item.ad_accounts ]
}

const data = computed(() => {
  return blockListsStore.blockLists.filter(item => item.existing !== false)
})

const selected = reactive(new Set())

const dialogStore = useDialogStore()
const addBlockList = () => {
  dialogStore.open(CreateBlockListDialog, {})
}

const confirmModal = useConfirmModal()

const edit = (item: any) => {
  dialogStore.open(CreateBlockListDialog, { item })
}

const copyItem = (item: any) => {
  blockListsStore.copy(item)
}

const deleteItem = (e: MouseEvent, item: any) => {
  confirmModal.open(e, "Are you sure you want to delete the selected \nblocklist?", () => {
    blockListsStore.deleteBlockLists([ item.id ])
  })
}

const deleteItems = (e: MouseEvent) => {
  confirmModal.open(e, "Are you sure you want to delete selected blocklists?", () => {
    blockListsStore.deleteBlockLists(Array.from(selected.values()).map((item: any) => item.id))
    selected.clear()
  })
}

const searchValue = ref("")

useTitle("Blocklists | Reply200")

const uiStore = useUiStore()


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(TheHeader, { title: "Blocklists" }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(VButton, {
            class: "density mr-2",
            onClick: addBlockList
          }, {
            default: _withCtx(() => [
              _createVNode(AddIcon),
              _createTextVNode(" Add blocklist")
            ]),
            _: 1
          }),
          _createVNode(VSocialSelect, {
            modelValue: socialValue.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((socialValue).value = $event))
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(VAuthInput, {
            modelValue: searchValue.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((searchValue).value = $event)),
            icon: SearchIcon,
            placeholder: "Search",
            class: "ml-auto light",
            clearable: ""
          }, null, 8, ["modelValue"])
        ])
      ]),
      _createVNode(Table, {
        modelValue: selected,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_isRef(selected) ? (selected).value = $event : null)),
        columns: columns,
        data: _unref(data),
        "row-key": "id",
        checkable: "",
        "default-sort": "block_words",
        search: searchValue.value,
        loading: !_unref(blockListsStore).loaded,
        "hide-stub": _unref(uiStore).showBM
      }, {
        "alt-header": _withCtx(() => [
          _createVNode(VButton, {
            secondary: "",
            density: "",
            class: "ml-1",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (deleteItems($event)))
          }, {
            default: _withCtx(() => [
              _createVNode(DeleteIcon),
              _hoisted_5
            ]),
            _: 1
          })
        ]),
        assets: _withCtx(({ item }) => [
          _createVNode(AssetsCell, {
            items: getAssets(item)
          }, null, 8, ["items"])
        ]),
        blockFormats: _withCtx(({ item }) => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formats.filter(i => item[i]), (format) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(format.replace(/_/g, " ")), 1))
          }), 256))
        ]),
        actions: _withCtx(({ item }) => [
          _createElementVNode("div", _hoisted_7, [
            _createVNode(IconButton, {
              onClick: ($event: any) => (edit(item))
            }, {
              default: _withCtx(() => [
                _createVNode(EditIcon)
              ]),
              _: 2
            }, 1032, ["onClick"]),
            _createVNode(IconButton, {
              onClick: ($event: any) => (copyItem(item))
            }, {
              default: _withCtx(() => [
                _createVNode(CopyIcon)
              ]),
              _: 2
            }, 1032, ["onClick"]),
            _createVNode(IconButton, {
              onClick: ($event: any) => (deleteItem($event, item))
            }, {
              default: _withCtx(() => [
                _createVNode(DeleteIcon)
              ]),
              _: 2
            }, 1032, ["onClick"])
          ])
        ]),
        _: 1
      }, 8, ["modelValue", "data", "search", "loading", "hide-stub"]),
      _createVNode(EmptyBMs)
    ])
  ], 64))
}
}

})